var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.73,13.84A8.22,8.22,0,0,0,11.68,8a8.19,8.19,0,0,0,.19,11.81V28a1.42,1.42,0,0,0,.74,1.25,1.35,1.35,0,0,0,.68.17,1.37,1.37,0,0,0,.73-.28l3.41-2.27,3.41,2.27a1.5,1.5,0,0,0,.71.24,1.41,1.41,0,0,0,1.27-.66A1.41,1.41,0,0,0,23,28V19.91l.28-.25A8.26,8.26,0,0,0,25.73,13.84ZM11.49,11.33a6.52,6.52,0,0,1,6-4v0A6.67,6.67,0,0,1,20,7.8a6.52,6.52,0,0,1,2.13,1.42,6.37,6.37,0,0,1,1.42,2.12A6.51,6.51,0,0,1,20,19.85a6.52,6.52,0,0,1-8.52-8.52Zm9.84,16.09-3.41-2.28a.85.85,0,0,0-.47-.13.84.84,0,0,0-.46.13l-3.41,2.28V21.05a8.12,8.12,0,0,0,7.75.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.36,17.14a3.89,3.89,0,0,0,2.14.64,3.85,3.85,0,0,0,3.2-6,3.85,3.85,0,0,0-3.95-1.64,3.83,3.83,0,0,0-3,3A3.83,3.83,0,0,0,14,15.41,3.91,3.91,0,0,0,15.36,17.14Zm.16-4a2.24,2.24,0,0,1,.79-1,2.19,2.19,0,0,1,1.19-.36,2.15,2.15,0,0,1,2.14,2.14,2.19,2.19,0,0,1-.36,1.19,2.24,2.24,0,0,1-1,.79,2.19,2.19,0,0,1-1.24.12A2.13,2.13,0,0,1,16,15.45a2.13,2.13,0,0,1-.47-2.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.196b0fc2c448ced127a25ae93cdb0411.svg";
export { ForwardRef as ReactComponent };